import { AbstractMermaidTokenBuilder } from '../common/index.js';

export class RadarTokenBuilder extends AbstractMermaidTokenBuilder {
  public constructor() {
    super(['radar-beta']);
  }
}
